import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createExternalAsset,
  deleteExternalAsset,
  listExternalAssets,
  updateExternalAsset,
} from '@/lib/externalAssetsApi'
import type { ExternalAssetUpdate } from '@/types/externalAsset'

const EXTERNAL_ASSETS_KEY = ['external-assets'] as const

export function useExternalAssets() {
  return useQuery({
    queryKey: EXTERNAL_ASSETS_KEY,
    queryFn: listExternalAssets,
    staleTime: 60_000,
  })
}

export function useCreateExternalAsset() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createExternalAsset,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXTERNAL_ASSETS_KEY })
    },
  })
}

export function useUpdateExternalAsset() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ExternalAssetUpdate }) =>
      updateExternalAsset(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXTERNAL_ASSETS_KEY })
    },
  })
}

export function useDeleteExternalAsset() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteExternalAsset,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXTERNAL_ASSETS_KEY })
    },
  })
}
